module.exports = __webpack_public_path__ + "media/metronic/_theme/media/flags/079-st-barts-d96d17598867b8654969135c38fe5643.svg";